import { Filters, FiltersFormData } from '../model/filterTypes';

const FIELD_MAPPING: Record<string, { formField: string; defaultValue: any }> = {
  revisionStatus: { formField: 'revisionStatus', defaultValue: '' },
  type: { formField: 'type', defaultValue: '' },
  elaborationDate: { formField: 'elaborationDate', defaultValue: null },
  approvalDate: { formField: 'approvalDate', defaultValue: null },
  effectiveDate: { formField: 'effectiveDate', defaultValue: null },
  validFrom: { formField: 'validFrom', defaultValue: null },
  validUntil: { formField: 'validUntil', defaultValue: null },
  requestDate: { formField: 'requestDate', defaultValue: null },
  revision: { formField: 'revision', defaultValue: 0 },
  user: { formField: 'elaborationApproval', defaultValue: '' },
  branchId: { formField: 'branchId', defaultValue: 0 },
  hasTraining: { formField: 'hasTraining', defaultValue: null },
  status: { formField: 'status', defaultValue: '' },
  stage: { formField: 'stage', defaultValue: '' },
  distribution: { formField: 'distribution', defaultValue: '' },
  format: { formField: 'format', defaultValue: '' },
  validityDate: { formField: 'validityDate', defaultValue: null },
  physicalLocation: { formField: 'physicalLocation', defaultValue: '' },
  isExternal: { formField: 'isExternal', defaultValue: null },
  elaboratedBy: { formField: 'elaboratedBy', defaultValue: '' },
  approvedBy: { formField: 'approvedBy', defaultValue: '' },
  verifiedBy: { formField: 'verifiedBy', defaultValue: '' },
  verificationDate: { formField: 'verificationDate', defaultValue: null },
  documentType: { formField: 'documentType', defaultValue: '' },
};

export function mapFiltersToFormData(filters: Filters): FiltersFormData {
  const formData = {} as FiltersFormData;

  Object.entries(FIELD_MAPPING).forEach(([storeField, { formField, defaultValue }]) => {
    const value = filters[storeField as keyof Filters];
    const shouldUseDefault = value === null || value === undefined || value === '';
    (formData as any)[formField] = shouldUseDefault ? defaultValue : value;
  });

  return formData;
}

export function mapFormDataToFilters(formData: FiltersFormData): Partial<Filters> {
  const filters: Partial<Filters> = {};

  Object.entries(FIELD_MAPPING).forEach(([storeField, { formField, defaultValue }]) => {
    const value = formData[formField as keyof FiltersFormData];

    const isInvalidDate = value instanceof Date && isNaN(value.getTime());

    if (
      value !== undefined &&
      value !== null &&
      value !== '' &&
      value !== defaultValue &&
      !isInvalidDate
    ) {
      (filters as any)[storeField] = value;
    }
  });

  return filters;
}
